(function () {
  'use strict';

  const DISCOUNT_CMYK      = 2000;
  const DISCOUNT_CMYK_DRUM = 3000;
  const DISCOUNT_MONO_DRUM = 1000;

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function calcDiscount(checkedItems, isCmyk, isMono) {
    const hasDrum    = checkedItems.some(i => i.drum);
    const tonerCount = checkedItems.filter(i => !i.drum).length;
    if (isCmyk && hasDrum && tonerCount >= 4) return DISCOUNT_CMYK_DRUM;
    if (isCmyk && tonerCount >= 4)            return DISCOUNT_CMYK;
    if (isMono && hasDrum)                    return DISCOUNT_MONO_DRUM;
    return 0;
  }

  function updateWidget(wrapper) {
    const pid       = wrapper.dataset.pid;
    const isCmyk    = wrapper.dataset.isCmyk === 'true';
    const isMono    = wrapper.dataset.isMono === 'true';
    const basePrice = parseInt(wrapper.dataset.basePrice, 10);
    const baseVid   = wrapper.dataset.baseVid;

    const items = [{ vid: baseVid, price: basePrice, drum: false }];

    wrapper.querySelectorAll('.tca-fbt__cb').forEach(cb => {
      const item  = cb.closest('.tca-fbt__item');
      const price = parseInt(cb.dataset.price, 10);
      const vid   = cb.dataset.vid;
      const drum  = cb.dataset.drum === 'true';
      if (item) item.dataset.active = cb.checked ? 'true' : 'false';
      if (cb.checked) items.push({ vid, price, drum });
    });

    const subtotal  = items.reduce((s, i) => s + i.price, 0);
    const discount  = calcDiscount(items, isCmyk, isMono);
    const total     = Math.max(subtotal - discount, 0);
    const itemCount = items.length;

    const subEl   = document.getElementById('tca-sub-'      + pid);
    const origEl  = document.getElementById('tca-orig-'     + pid);
    const discEl  = document.getElementById('tca-disc-'     + pid);
    const saveEl  = document.getElementById('tca-save-'     + pid);
    const saveRow = document.getElementById('tca-save-row-' + pid);
    const btn     = document.getElementById('tca-btn-'      + pid);

    if (discount > 0) {
      if (subEl)   subEl.textContent  = 'Save ' + moneyFormat(discount) + ' when you buy all ' + itemCount + ' together';
      if (origEl)  origEl.textContent = moneyFormat(subtotal);
      if (discEl)  discEl.textContent = moneyFormat(total);
      if (saveEl)  saveEl.textContent = 'You save ' + moneyFormat(discount) + '!';
      if (saveRow) saveRow.style.display = '';
    } else {
      if (subEl)   subEl.textContent  = itemCount + ' items selected';
      if (origEl)  origEl.textContent = '';
      if (discEl)  discEl.textContent = moneyFormat(subtotal);
      if (saveEl)  saveEl.textContent = '';
      if (saveRow) saveRow.style.display = 'none';
    }

    if (btn) {
      btn.disabled        = items.length < 2;
      btn.dataset.items   = JSON.stringify(items);
      btn.dataset.discount = discount;
    }
  }

  async function addToCart(items, discount) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(i => ({ id: i.vid, quantity: 1 })) })
      });
      if (!res.ok) throw new Error('Cart add failed');
      if (discount > 0) {
        try { await fetch('/discount/TONERSFBT'); } catch(e) {}
      }
      if (window.theme && window.theme.openCart) {
        window.theme.openCart();
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('FBT cart error:', err);
      alert('Sorry, there was an issue adding items to cart. Please try again.');
    }
  }

  function initFBT(wrapper) {
    updateWidget(wrapper);
    wrapper.querySelectorAll('.tca-fbt__cb').forEach(cb => {
      cb.addEventListener('change', () => updateWidget(wrapper));
    });
    const pid = wrapper.dataset.pid;
    const btn = document.getElementById('tca-btn-' + pid);
    if (btn) {
      btn.addEventListener('click', async function () {
        const items    = JSON.parse(this.dataset.items || '[]');
        const discount = parseInt(this.dataset.discount || '0', 10);
        if (items.length < 2) return;
        const btnText    = this.querySelector('.tca-fbt__btn-text');
        const btnLoading = this.querySelector('.tca-fbt__btn-loading');
        this.disabled = true;
        if (btnText)    btnText.style.display    = 'none';
        if (btnLoading) btnLoading.style.display = '';
        await addToCart(items, discount);
        this.disabled = false;
        if (btnText)    btnText.style.display    = '';
        if (btnLoading) btnLoading.style.display = 'none';
      });
    }
  }

  function boot() {
    document.querySelectorAll('.tca-fbt').forEach(initFBT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
